// Visual primitives used by the interview dialogue and JSON lead magnets.
export const chatStyles = {
	messageWidth:
		'mx-auto w-[calc(100%_-_24px)] max-w-[720px] sm:w-[calc(100%_-_48px)]',
	footer:
		'shrink-0 px-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-2 sm:px-6 sm:pb-[max(1.25rem,env(safe-area-inset-bottom))]',
	messageBody:
		'min-w-0 text-base leading-[1.6] text-black [&>:first-child]:mt-0',
	userBubble:
		'whitespace-pre-wrap rounded-2xl bg-[#E5E7EB] px-4 py-3 text-base leading-[1.55] text-black',
	composer:
		'relative font-[Onest,Arial,sans-serif] rounded-2xl border border-gray-4/60 bg-white px-[7px] pb-[7px] pt-[13px] transition-colors focus-within:border-gray-4',
	field:
		'block w-full resize-none overflow-y-auto border-none bg-transparent px-1 py-0 text-base leading-6 text-black outline-none placeholder:text-gray-3/70 disabled:cursor-not-allowed disabled:placeholder:text-gray-4',
	sendButton:
		'flex size-8 items-center justify-center rounded-lg border-none transition-all duration-150 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent',
	sendActive: 'cursor-pointer bg-black text-white',
	sendEmpty: 'cursor-not-allowed bg-gray-5 text-gray-4',
	actions:
		'grid w-full grid-cols-2 gap-2 [&>*]:h-auto [&>*]:min-h-9 [&>*]:w-full [&>*]:min-w-0 [&>*]:justify-center [&>*]:px-3 [&>*]:py-2 [&>*]:text-center [&>:last-child:nth-child(odd)]:col-span-2',
};
